<template>
  <DemoTemplate
    title="Alert, Notification, and Banner"
    description="A growing collection of 46 alert, notification, and banner components built with Next.js and TailwindCSS."
    :columns="2"
  >
    <div class="group/item relative" v-for="cmp in componentList">
      <component :is="cmp" />
    </div>
    <div class="group/item relative flex items-center justify-center" v-for="cmp in componentList2">
      <component :is="cmp" />
    </div>
  </DemoTemplate>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from "vue";
import DemoTemplate from "../templates/DemoTemplate.vue";

const componentList = [
  defineAsyncComponent(() => import("../atoms/notifications/Notification-01.vue")),
  defineAsyncComponent(() => import("../atoms/notifications/Notification-02.vue")),
  defineAsyncComponent(() => import("../atoms/notifications/Notification-03.vue")),
  defineAsyncComponent(() => import("../atoms/notifications/Notification-04.vue")),
  defineAsyncComponent(() => import("../atoms/notifications/Notification-05.vue")),
  defineAsyncComponent(() => import("../atoms/notifications/Notification-06.vue")),
  defineAsyncComponent(() => import("../atoms/notifications/Notification-07.vue")),
  defineAsyncComponent(() => import("../atoms/notifications/Notification-08.vue")),
  defineAsyncComponent(() => import("../atoms/notifications/Notification-09.vue")),
  defineAsyncComponent(() => import("../atoms/notifications/Notification-10.vue")),
  defineAsyncComponent(() => import("../atoms/notifications/Notification-11.vue")),
  defineAsyncComponent(() => import("../atoms/notifications/Notification-12.vue")),
];

const componentList2 = [
  defineAsyncComponent(() => import("../atoms/notifications/Notification-13.vue")),
  defineAsyncComponent(() => import("../atoms/notifications/Notification-14.vue")),
  defineAsyncComponent(() => import("../atoms/notifications/Notification-15.vue")),
  defineAsyncComponent(() => import("../atoms/notifications/Notification-16.vue")),
];
</script>
